import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Code2, Server, ShieldCheck, Network, Wrench, GraduationCap, Smartphone, Cpu, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Reveal, Overline } from "@/components/public/ui";

const ICONS = { code: Code2, smartphone: Smartphone, network: Network, shield: ShieldCheck, wrench: Wrench, server: Server, "graduation-cap": GraduationCap };

export default function Services() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/services").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0F2A6B] to-[#0A1F52] relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 relative">
          <Overline><span className="text-[#4CB944]">Services informatiques</span></Overline>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-white font-head">Nos services</h1>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl">Un accompagnement IT complet, du conseil au support.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
          {items.map((s, i) => {
            const Icon = ICONS[s.icon] || Cpu;
            return (
              <Reveal key={s.id} delay={i * 0.06}>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`} className="group block h-full p-6 rounded-2xl bg-white border border-slate-200 hover:shadow-lg hover:-translate-y-1 transition-all">
                  <div className="w-12 h-12 rounded-xl bg-[#0F2A6B] grid place-items-center mb-4 group-hover:bg-[#4CB944] transition-colors"><Icon className="w-6 h-6 text-white" /></div>
                  <h3 className="text-lg font-semibold text-slate-900 font-head">{s.name}</h3>
                  <p className="mt-2 text-sm text-slate-600">{s.short_desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[#0F2A6B] group-hover:text-[#4CB944]">En savoir plus <ArrowRight className="w-4 h-4" /></span>
                </Link>
              </Reveal>
            );
          })}
          {items.length === 0 && <p className="text-slate-500">Aucun service publié.</p>}
        </div>
      </section>
    </div>
  );
}
